<template>

	<div 
	class="object" 
	ref="object" 
	:style="{ 'background-image': 'url(' + require('../../assets/images/website/' + sprite) + ')' }"
	@click="fly"
	></div>
	
</template>

<script>

	import { TweenMax, TimelineMax } from 'gsap'

	export default {

		props: ['object', 'width', 'frames', 'height', 'imageRight', 'imageLeft', 'audio'],

		data() {

			return {

				sprite: '',
				tween: '',
				widthRatio: 1,
				heightRatio: 1,
				step: 0,
				animate: false


			}

		},

		beforeMount: function() {

			this.sprite = this.imageRight;

		},

		mounted: function () {

			window.addEventListener('resize', () => this.resize());
			this.resize()

			this.tween = TweenMax.to( 

				this.$refs.object, 
				(this.frames * 0.15), 
				{ 
					backgroundPosition:"0px "+ (-(this.height * this.frames))+"px",
					ease:SteppedEase.config(this.frames), 
					repeat:-1,
					paused:false,
					repeatDelay: -0.15 
				}

			);

 		},

 		methods: {

 			resize() {

 				var width = window.innerWidth;
 				var height = window.innerHeight;

 				this.widthRatio = width / 1920;
 				this.heightRatio = (this.widthRatio * 6520) / 6520;

 				this.$refs.object.style.height = this.height + "px";
 				this.$refs.object.style.width = this.width + "px";
 				this.$refs.object.style.transform = "scale("+ this.widthRatio +")";

 			},

 			fly() {

 				var self = this;

 			
				if( !this.animate ) {
				
					this.step++;	
					this.animate = true;
					self.tween.timeScale(2);	

					// play audio

					this.audio.play( 'vlieg-'+Math.floor((Math.random() * 3) + 1) );

					// als de laatste step is geweest, weer op 0 zetten;			

					switch( this.step ) {

						case 1:

							this.sprite = this.imageRight;
							TweenMax.to( 
								this.$refs.object,
								6, // 6
								{

									bezier:[
								
										{ left:'43%', top:"88.0%", rotation: "-5deg" }, 
										{ left:'50%', top:"83.0%", rotation: "-10deg" }, 
										{ left:'58%', top:"81.3%", rotation: "0deg" }

									], 
									
									ease:Sine.easeInOut, 
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); } 
							 	});

						break;

						case 2:

							TweenMax.to( 
								this.$refs.object,
								5, // 5
								{
									bezier:{

										type:"soft",
										values:[
								
											{ left:'54.0%', top:"76.0%", rotation: "-5deg" }, 
											{ left:'66.0%', top:"70.0%", rotation: "-10deg" }, 
											{ left:'71.5%', top:"68.7%", rotation: "0deg" }

										]

									}, 
									ease:Linear.easeNone,
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); self.sprite = self.imageLeft; } 
						 		}
						 	);

						break;					

						case 3:

							TweenMax.to( 
								this.$refs.object,
								4, // 4 
								{
									bezier:{

										// type:"soft",
										values:[
								
											{ left:'52%', top:"64.7%", rotation: "-45deg" }, 
											{ left:'35%', top:"57.3%", rotation: "0deg" }

										]
										
									}, 
									ease:Sine.easeOut, 
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); /* self.sprite = self.imageLeft; */ } 
						 		}
						 	);						

						break;	

						case 4:

							TweenMax.to( 
								this.$refs.object,
								6, // 6 
								{
									bezier:{

										// type:"soft",
										values:[
								
											{left:'12.1%', top:"44.7%", rotation: "-45deg" }, 
											{left:'20.1%', top:"40.1%", rotation: "5deg" }, 
											{left:'24.5%', top:"38.3%", rotation: "0deg" }

										]
										
									}, 
									ease:Sine.easeOut, 
									onUpdate: function() { 

										if( this.progress().toFixed(2) > 0.25 && self.sprite != self.imageRight ) {

											self.sprite = self.imageRight;

										} 

									},
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); /* self.sprite = self.imageLeft; */ } 
						 		}
						 	);							

						break;	

						case 5:
							
							TweenMax.to( 
								this.$refs.object,
								6, // 6 
								{
									bezier:{

										type:"soft",
										values:[
								
											{ left:'48.5%', top:"34.5%", rotation: "-0deg" }, 
											{ left:'40.5%', top:"30.5%", rotation: "-180deg" }, 
											{ left:'32.5%', top:"34.5%", rotation: "-360deg" }, 
											{ left:'40.5%', top:"36.1%", rotation: "-370deg" },
											{ left:'48.5%', top:"34.5%", rotation: "-365deg" }, 
											{ left:'58.5%', top:"24.6%", rotation: "-360deg" }

										]
										
									}, 
									ease:Sine.easeOut, 
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); TweenMax.set( self.$refs.object, {rotation:'0deg'} ); } 
						 		}
						 	);


						break;	

						case 6:

							TweenMax.to( 
								this.$refs.object,
								6, // 6 
								{
									bezier:{

										values:[
								 
											{ left:'70%', top:"20%", rotation: "15deg" }, 
											{ left:'48%', top:"15%", rotation: "-5deg" },
											{ left:'33%', top:"10%", rotation: "0deg" }, 

										]
										
									}, 
									ease:Sine.easeOut, 
									onUpdate: function() { 

										if( this.progress().toFixed(2) > 0.14 && self.sprite != self.imageLeft ) {

											self.sprite = self.imageLeft;

										} 

									},								
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); /* self.sprite = self.imageLeft; */ } 
						 		}
						 	);

						break;


						case 7:

							TweenMax.to( 
								this.$refs.object,
								15, 
								{
									bezier:{
										
										type:"soft",
										values:[
								 
											{ left:'10%', top:"11%", rotation: "-5deg" },
											{ left:'40%', top:"25%", rotation: "35deg" },
											{ left:'100%', top:"50%", rotation: "0deg" },
											{ left:'0%', top:"75%", rotation: "35deg" },
											{ left:'40%', top:"93%", rotation: "0deg" },

										]
										
									}, 
									ease:Sine.easeInOut, 
									onUpdate: function() {

										if( this.progress().toFixed(2) > 0.17 && self.sprite != self.imageRight ) {

											self.sprite = self.imageRight;
											self.$refs.object.style.zIndex = 11;

										}

										if( this.progress().toFixed(2) > 0.47 && self.sprite != self.imageLeft ) {

											self.sprite = self.imageLeft;

										}									

										if( this.progress().toFixed(2) > 0.71 && self.sprite != self.imageRight ) {

											self.sprite = self.imageRight;

										}


									},
									onStart: function() { self.$refs.object.style.zIndex = 1 },
							 		onComplete: function() { self.animate = false; self.tween.timeScale(1); self.step = 0; } 
						 		}
						 	);

						break;	


					}
				}

 			}

 		},

 	}

 </script>

<style lang="scss" scoped>
 	
 .object {

 	-webkit-tap-highlight-color: rgba(0,0,0,0);
 	background-repeat: no-repeat;
 	position: absolute;
 	background-size: cover;
 	z-index: 11;

 	top: 93%;
 	left: 40%;
 	cursor: pointer;

 }

 </style>


// WEBPACK FOOTER //
// Vlieg.vue?47e01eeb